<template>
  <el-container class="member-manage-container" :style="{overflow:isMsg?'hidden':'auto'}">
    <el-header style="padding: 0;height: 60px">
      <img
        :src="logoUrl"
        v-if="logoUrl"
        class="member-manage-logo defuault-image"
        v-show="isOpen === false"
      />
      <i v-else class="iconfont icon-bjybju logo-new member-manage-logo" v-show="isOpen === false"></i>
      <!--<img src="../assets/images/zy-logo2.png" class="member-manage-logo-hide" v-show="isOpen">-->
      <i class="iconfont icon-bjy- member-manage-logo-hide" v-show="isOpen"></i>
      <!--<label class="p-l-20 member-manage-title">{{title}}</label>-->
      <i
        @click="changeClose"
        v-show="this.$route.path !== '/home/data-center'"
        :class="
          this.$route.path !== '/home/data-center' ? 'icon-open' : 'icon-close'
        "
        v-if="isOpen === false"
        class="open-close iconfont icon-shouqi"
      ></i>
      <i
        @click="changeOpen"
        :class="
          this.$route.path !== '/home/data-center' ? 'icon-open' : 'icon-close'
        "
        v-show="this.$route.path !== '/home/data-center'"
        v-if="isOpen === true"
        class="open-close iconfont icon-shouqi1"
      ></i>
      <el-menu
        router
        :default-active="pathNow"
        class="el-menu-demo member-manage-top-menu"
        mode="horizontal"
      >
        <el-menu-item
          v-for="item in menuList"
          :key="item.path"
          :index="item.path"
          @click="handleMenuTop(item)"
        >{{ item.name }}</el-menu-item>
      </el-menu>
      <div class="setBtn">
        <div class="logout" @click="logoutNow" style="margin-right: 20px">
          <i class="iconfont icon-tuichu"></i>
          <span></span>
        </div>
        <div class="user-name-login" @click="openDialog">{{ realname }}</div>
        <div class="user-head-img" @click="openDialog">
          <img v-if="headImg" :src="headImg" alt />
          <img v-if="!headImg" src="../assets/images/defaultHeadImg.jpg" alt />
        </div>
      </div>
      <AppMessage />
      <app-service></app-service>
    </el-header>
    <!--登录密码头像修改弹窗-->
    <el-dialog
      class="cellDialog base-dialog account-setting-dialog account_setting"
      title="账户设置"
      :visible.sync="adddialog"
      width="540px"
    >
      <el-tabs v-model="type">
        <el-tab-pane label="资料编辑" name="1">
          <el-form ref="form1" :model="form1">
            <el-upload
              class="avatar-uploader"
              name="file_upload"
              :action="uploadURL"
              :show-file-list="false"
              :on-success="handleCoverAvatarSuccess"
              :before-upload="beforeCoverAvatarUpload"
            >
              <div v-if="coverUrl" class="upload_img">
                <img :src="coverUrl" class="avatar" />
                <div class="modify_img">点击修改</div>
              </div>
              <img v-else src="../assets/images/Group.png" class="default-acivity" />

              <!-- <img v-if="coverUrl" :src="coverUrl" class="avatar"> -->
              <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
            </el-upload>
            <p class="userData">
              <span>企 业 ID :</span>
              {{ companyId }}
            </p>
            <p class="userData">
              <span>用&nbsp;户&nbsp;名&nbsp;:</span>
              {{ form.username }}
            </p>
            <p class="userData">
              <span>电&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;话&nbsp;:</span>
              {{ form.mobile }}
            </p>
            <!-- <el-form-item label="用户名:" label-width="50px">
              <el-input disabled class="stockInput" type="text" v-model="form.username" auto-complete="off" placeholder="输入用户名"></el-input>
            </el-form-item>
            <el-form-item label="电话:" label-width="50px">
              <el-input disabled class="stockInput" type="text" v-model="form.mobile" auto-complete="off" placeholder="输入电话"></el-input>
            </el-form-item>-->
          </el-form>
          <div class="dialog-footer" style="margin:25px 10px;text-align:center">
            <el-button
              class="dialog-cancel-btn"
              @click="adddialog = false"
              style="margin:0 10px 0 0"
            >取 消</el-button>
            <el-button
              class="dialog-confirm-btn"
              style="margin-left:10px;float:none;"
              type="primary"
              @click="confirmAdd()"
            >保 存</el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="账户密码" name="2" style="padding-top: 20px;">
          <el-form ref="form" :model="form" :rules="rules" label-position="right">
            <el-form-item label="原 密 码:" prop="oldPwd" :label-width="addLabelWidth">
              <el-input type="password" v-model.trim="form.oldPwd" class="h-40 w-200"></el-input>
            </el-form-item>
            <el-form-item label="新 密 码:" prop="password" :label-width="addLabelWidth">
              <el-input type="password" v-model.trim="form.password" class="h-40 w-200"></el-input>
            </el-form-item>
            <el-form-item label="确认密码:" prop="confirmPsd" :label-width="addLabelWidth">
              <el-input type="password" v-model.trim="form.confirmPsd" class="h-40 w-200"></el-input>
            </el-form-item>
          </el-form>
          <div class="dialog-footer" style="margin:25px 0;text-align:right">
            <el-button
              class="dialog-cancel-btn"
              @click="adddialog = false"
              style="margin:0 10px 0 0"
            >取 消</el-button>
            <el-button
              class="dialog-confirm-btn"
              style="margin-left:10px;float:none;"
              type="primary"
              @click="confirmAdd()"
            >保 存</el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <el-container style="padding-top: 60px">
      <div
        :class="
          isOpen && this.$route.path !== '/home/data-center' ? 'short' : ''
        "
        v-if="this.$route.path !== '/home/update-log' "
        style="position: fixed; left: 0;height: 100%"
      >
        <el-aside
          width="auto"
          :class="this.$route.path !== '/home/data-center' ? '' : 'hide-breadcrumb'"
          v-show="leftmenu"
          style="max-width: 200px; height: 100%;box-shadow:2px 0 6px rgba(1,26,51,0.3)"
        >
          <setCenterLeft :isOpen="isOpen" :topCurrentPath="pathNow"></setCenterLeft>
        </el-aside>
      </div>
      <el-container
        :class="(this.$route.path == '/home/data-center' || this.$route.path == '/home/update-log')?'shortNo': (isOpen?'shortLeft':'langLeft')"
      >
        <el-main class="main-wrap" style>
          <div
            class="produce-nav-title"
            :class="
              this.$route.path !== '/home/data-center' ? ( this.$route.path !== '/home/update-log'? '': 'hide-breadcrumb') : 'hide-breadcrumb'
            "
          >
            <el-breadcrumb separator="/">
              <el-breadcrumb-item :to="item.Rpath" v-for="(item, index) in breadcrumb" :key="index">
                <span>{{ item.name }}</span>
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
          </keep-alive>
          <router-view v-if="!$route.meta.keepAlive"></router-view>
          <el-footer v-show="leftmenu" class="common-footer">Copyright©{{year}} 智盈数科</el-footer>
        </el-main>
      </el-container>
    </el-container>
    <appMessageBox v-if="isMsg" :isExpired="isExpired" :msgList="msgList" @close="isMsg=$event" />
  </el-container>
</template>

<script>
import { mapState } from 'vuex';
import setCenterLeft from './common/set-center-left.vue';
import Lockr from 'lockr';
import '../assets/css/logo/iconfont.css';
import { logout, editPwdAndHeadImg, fetchMenuList } from '@/api/customer.js';
import { checkAccountValid } from '@/api/manage-api.js';
import { getProductModel } from '@/api/set.js';
import {
  API_IMG_HOST,
  API_HOST,
  YZ_HOST,
  FRONTEND_MARKET_URL
} from '../api/local.js';
import AppService from '@/components/common/app-service';
import AppMessage from '@/components/common/app-message';
import appMessageBox from '@/components/common/app-message-box';
import { getCusTypes } from '@/api/set.js';
export default {
  name: 'Home',
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入确认密码'));
      } else if (value !== this.form.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };

    // 验证密码
    let checkPassWord = (rule, value, callback) => {
      const check = /^(?=.{8})(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)(?=.*?[*?!&￥$%^#,./@";:><\[\]}{\-=+_\\|》《。，、？’‘“”~ `]).*$/;
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (!check.test(value)) {
        callback(new Error('密码需包含数字+特殊字符+英文字母大小写且长度不小于8位'));
      } else {
        callback();
      }
    };
    return {
      year: '',
      menuList: [],
      logoUrl: Lockr.get('userInfo').logo_url,
      type: '1',
      isOpen: false,
      adddialog: false,
      form1: {
        username: '',
        mobile: ''
      },
      companyId: '',
      form: {
        oldPwd: '',
        password: '',
        confirmPsd: ''
      },
      isShowResource: false,
      rules: {
        oldPwd: [{ required: true, message: '请输入原密码' }],
        password: [
          { required: true, message: '请输入新密码' },
          { validator: checkPassWord, trigger: 'blur' }
        ],
        confirmPsd: [
          { required: true, message: '请输入确认新密码' },
          { validator: validatePass, trigger: 'blur' }
        ]
      },
      addLabelWidth: '89px',
      coverUrl: '',
      realname: '',
      headImg: '',
      img: '',
      title: '',
      pathNow: '',
      index: '/home/data-center',
      yunxiao: '/home/yxqa',
      api_HOST_MAKETING: '',
      path: null,
      topCurrentPath: null,
      isresource: false,
      isMsg: false,
      msgList: [],
      isExpired: false
    };
  },
  computed: {
    ...mapState(['breadcrumb', 'leftmenu']),
    uploadURL() {
      return API_HOST + 'admin/Upload/upload';
    }
  },
  watch: {
    $route(to, from) {
      this.path = to.path;
      this.handleWatchRoute();
    }
  },
  mounted() {
    this.companyId = Lockr.get('userInfo').id || '';
    this.getProductModel();
    this.getEarlyWarnMsg();
    if (this.$route.path === '/home/yxwelcome') {
      sessionStorage.setItem('currentPath', '/home/yxwelcome');
      let yxList = this.$router.options.routes[3];
      let newYxList = [];
      let newYxListParent = [];
      yxList.children.map(function(item, index) {
        if (
          item.path !== 'yxwelcome' &&
          (item.path === 'yxdealer' ||
            item.path === 'yxaccount' ||
            item.path === 'yxaccount_tx' ||
            item.path === 'yxmarketing' ||
            item.path === 'yxbank' ||
            item.path === 'yxgroup' ||
            item.path === 'yxqa' ||
            item.path === 'yxoperatelog')
        ) {
          newYxList.push({
            id: index,
            attributes: {
              icon: '',
              route: yxList.path + '/' + item.path
            },
            checked: false,
            text: item.meta.routeArr[1].name
          });
        }
      });
      newYxListParent.push({
        id: 1,
        attributes: {
          icon: '',
          route: 'home/yxwelcome'
        },
        identity: 'yunshang',
        name: '云商管理',
        children: newYxList,
        text: '云商管理'
      });
      Lockr.set('menuListLeft', newYxListParent);
      sessionStorage.setItem(
        'leftPath',
        yxList.path + '/' + yxList.children[0].path
      );
      this.$nextTick(() => {
        const currentPath = sessionStorage.getItem('currentPath');
        this.pathNow = currentPath ? currentPath : '/home/yxwelcome';
      });
    } else {
      this.$nextTick(() => {
        let currentPath = sessionStorage.getItem('currentPath');
        if (this.$route.path !== currentPath) {
          currentPath = this.$route.path;
          sessionStorage.setItem('currentPath', this.$route.path);
        }
        this.pathNow = currentPath ? currentPath : this.menuList[0].path;
      });
    }
    if (this.$route.path === '/home/product-manage' && !this.isresource) {
      this.$router.push('/home/data-center');
    }
  },
  components: {
    setCenterLeft,
    AppService,
    AppMessage,
    appMessageBox
  },
  methods: {
    handleMenuTop(item) {
      Lockr.set('pathNowIndex', item.children[0].id);
    },
    getEarlyWarnMsg() {
      let params = {
        id: Lockr.get('userInfo').id,
        subSysCode: 'ZY_INTELLIQUOR'
      };
      checkAccountValid(params).then(res => {
        if (!res.data.success) {
          return this.$message.error(res.data.msg);
        }
        this.msgList = res.data.result;
        if (this.msgList.length !== 0) {
          if (parseInt(res.data.result[0].days) <= 0) {
            this.isMsg = true;
            this.isExpired = true;
            window.localStorage.removeItem('GET_TIME');
            return;
          }
          this.isHintMessgae();
        } else {
          window.localStorage.removeItem('GET_TIME');
        }
      });
    },
    isHintMessgae() {
      let time = JSON.parse(window.localStorage.getItem('GET_TIME')) || {};
      const dt = new Date();
      let year = dt.getFullYear();
      let month = dt.getMonth() + 1;
      let day = dt.getDate();
      if (time.day !== day) {
        this.isMsg = true;
      } else if (time.month !== month) {
        this.isMsg = true;
      } else if (time.year !== year) {
        this.isMsg = true;
      }
      if (this.isMsg) {
        window.localStorage.setItem(
          'GET_TIME',
          JSON.stringify({ year, month, day })
        );
      }
    },
    // 获取产品modelid
    getProductModel() {
      getProductModel(52).then(res => {
        if (res.data.result.length == 0) {
          let newlist = [];
          Lockr.get('menuList').map(function(item, index) {
            if (item.perms !== 'resource') {
              newlist.push(item);
            }
          });
          this.isresource = false;
          this.menuList = newlist;
        } else {
          this.isresource = true;
          this.menuList = Lockr.get('menuList');
        }
      });
    },
    // 监听路由变化
    handleWatchRoute() {
      const menuList = JSON.parse(JSON.stringify(this.menuList));
      for (let item of menuList) {
        if (item.children.length > 0) {
          for (let kid of item.children) {
            for (let ele of kid.children) {
              if (ele.attributes.route === this.path) {
                console.log(this.path, 'this.path');
                this.pathNow = item.path;
                sessionStorage.setItem('currentPath', this.pathNow);
                break;
              }
            }
          }
        }
      }
    },
    // 传值到菜单子组件(打开)
    changeOpen() {
      this.isOpen = false;
    },
    // 传值到菜单子组件（关闭）
    changeClose() {
      this.isOpen = true;
    },
    // 打开修改密码弹窗
    openDialog() {
      this.adddialog = true;
      let userInfos = Lockr.get('userInfo');
      this.form.username = userInfos.username;
      this.form.mobile = userInfos.mobile;
    },
    // 确认修改头像密码
    confirmAdd() {
      if (this.type === '1') {
        editPwdAndHeadImg(
          this.type,
          this.coverUrl,
          this.form.oldPwd,
          this.form.confirmPsd
        ).then(res => {
          if (res.data.data) {
            this.adddialog = false;
            this.headImg = this.coverUrl;
          } else {
            _g.toastMsg('error', res.data.error);
          }
        });
      } else {
        this.$refs.form.validate(pass => {
          if (pass) {
            editPwdAndHeadImg(
              this.type,
              this.coverUrl,
              this.form.oldPwd,
              this.form.confirmPsd
            ).then(res => {
              if (res.data.data) {
                Lockr.rm('authKey');
                Lockr.rm('sessionId');
                Lockr.rm('userInfo');
                console.log('删除了对象home.vue');
                Lockr.rm('menuList');
                Lockr.rm('subSystems');
                Lockr.rm('menuListLeft');
                _g.toastMsg('success', '修改成功，请重新登录');
                router.push('/login');
              } else {
                _g.toastMsg('error', res.data.error);
              }
            });
          }
        });
      }
    },
    // 封面
    handleCoverAvatarSuccess(res, file) {
      this.coverUrl = res.data.path;
    },
    beforeCoverAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG && !isPNG) {
        this.$message.error('上传图片只能是 JPG/PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return (isJPG && isLt2M) || (isPNG && isLt2M);
    },
    // 退出
    logoutNow() {
      // this.$confirm('确认退出登录?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // })
      //   .then(() => {
      this.$alert('确认退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showCancelButton: true,
        type: 'warning',
        callback: action => {
          console.log(action);
          if (action == 'confirm') {
            logout().then(res => {
              if (res.data.code === 0) {
                sessionStorage.setItem('currentPath', '');
                Lockr.rm('authKey');
                Lockr.rm('sessionId');
                Lockr.rm('userInfo');
                console.log('删除了对象2home.vue');
                Lockr.rm('menuList');
                Lockr.rm('subSystems');
                Lockr.rm('menuListLeft');
                _g.toastMsg('success', '退出登录成功');
                router.push('/login');
              } else {
                _g.toastMsg('error', res.data.error);
              }
            });
          }
        }
      });
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    handleSelectAction(key) {
      if (key === '1') {
        router.push('/home/user-manage');
      } else if (key === '2') {
        router.push('/home/application-manage');
      }
    }
  },
  created() {
    this.year = new Date().getFullYear();
    this.API_IMG_HOST = API_IMG_HOST;
    this.img = require('../assets/images/zy.png');
    this.title = '数字化营销平台';
    this.logo_type = 1;
    this.menuList = Lockr.get('menuList') || [];
    let userInfos = Lockr.get('userInfo');
    this.realname = userInfos.realname;
    this.headImg = userInfos.avatar;
    this.coverUrl = userInfos.avatar;
  }
};
</script>

<style scoped>
.shortLeft {
  padding-left: 65px;
}
.shortNo {
  padding-left: 0;
}
.langLeft {
  padding-left: 200px;
}
.hide-breadcrumb {
  display: none;
}
.upload_img {
  position: relative;
}
.upload_img:hover .modify_img {
  display: inline-block;
}
.modify_img {
  position: absolute;
  height: 100%;
  width: 100%;
  background: #000;
  opacity: 0.6;
  display: none;
  top: 0;
  left: 0;
  color: #fff;
  font-size: 18px;
  line-height: 110px;
}
.con_padding {
  padding-left: 200px;
}
.short_padding {
  padding-left: 0px;
}
.account-setting-dialog .el-form-item {
  width: 425px;
}
.setBtn {
  width: auto;
}
.user-head-img {
  margin-left: 0;
}
.avatar-uploader {
  width: 110px;
  height: 110px;
  border-radius: 50%;
  margin: 10px auto 30px;
}
.avatar-uploader .el-upload {
  border-radius: 50%;
}
.avatar {
  width: 110px;
  height: 110px;
  display: block;
  border-radius: 50%;
}
.userData {
  width: 156px;
  margin: 15px auto;
  /*text-align: center;*/
}
.userData span {
  width: 66px;
  display: inline-block;
}
.icon-open {
  display: block !important;
  opacity: 1;
}
.icon-close {
  display: block !important;
  opacity: 0;
}
</style>
